import { Component, OnInit, ViewChild } from '@angular/core';
import { CategorizacionTramiteDto, ICategorizacionTramite } from '../../../../shared/interfaces/database/configuracion';
import { TableModule } from 'primeng/table';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CategorizacionTramiteService } from '../../../../services/database/categorizacionTramite.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, IHeader, LoadingPanelService, LocalService, noWhitespaceValidator, Utils } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { AdminCategorizacionesHistoricoComponent } from './admin-categorizaciones-historico/admin-categorizaciones-historico.component';

@Component({
  selector: 'app-admin-categorizaciones',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, TranslateModule, CustomTableComponent, AdminCategorizacionesHistoricoComponent,
    TableModule, ButtonModule, ConfirmPopupModule, DialogModule, InputTextModule,
    FormGroupErrorMessageComponent, CustomTitle
  ],
  providers: [ConfirmationService],
  templateUrl: './admin-categorizaciones.component.html',
  styleUrls: ['./admin-categorizaciones.component.scss']
})
export class AdminCategorizacionesComponent implements OnInit {
  formTitle = '';
  displayModal = false;
  categorizacionForm !: FormGroup;
  private _editCategorizacion !: ICategorizacionTramite | undefined;
  private originalValues: any;

  translations: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(AdminCategorizacionesHistoricoComponent) historico !: AdminCategorizacionesHistoricoComponent;
  role = AccessRole;

  constructor(private _ct: CategorizacionTramiteService, private _fb: FormBuilder, private _t: TranslateService,
    private _ms: MessageService, private _cs: ConfirmationService, public ls: LocalService, private _lps: LoadingPanelService
  ) {

    this.configureCategorizacionForm();
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      exito: this._t.get('common.exito'),
      advertencia: this._t.get('common.advertencia'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      categorizacion: this._t.get('common.categorizacion'),
      nuevaCategoria: this._t.get('msg.nuevaCategoria'),
      editarCategoria: this._t.get('msg.editarCategoria'),
      porFavorCompleteTodosLosCamposRequeridos: this._t.get('msg.porFavorCompleteTodosLosCamposRequeridos'),
      estasSeguroDeQueQuieresEliminarLaCategoria: this._t.get('msg.estasSeguroDeQueQuieresEliminarLaCategoria'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
    }));

    this.configColumns();
  }

  private configColumns() {
    this.customTable = {
      header: {
      } as IHeader,
      columns: [
        {
          field: 'descripcion',
          header: this.translations.categorizacion,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: ICategorizacionTramite) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          tooltip: {
            message: this.translations.requiereRolSeguridad
          },
          onClick: (event: Event, data: ICategorizacionTramite) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-0',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorialEliminado(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          onClick: (event: Event, data: ICategorizacionTramite) => this.deleteConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          },
          headerTooltip:{
            message: this.translations.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_SEC)
          }
        }
      ],
      settings: {
        table: {
          rows: 10,
        }
      }
    } as ICustomTable;

  }

  get isNewForm(): boolean {
    return this._editCategorizacion === undefined;
  }

  configureCategorizacionForm() {
    this.categorizacionForm = this._fb.group({
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]]
    });
  }

  openNewModal() {
    this.resetForm();
    this.formTitle = this.translations.nuevaCategoria;
    this._editCategorizacion = undefined;
    this.displayModal = true;
  }

  openEditModal(categorizacion: ICategorizacionTramite) {
    this.resetForm();
    this.formTitle = this.translations.editarCategoria;
    this._editCategorizacion = categorizacion;
    this.categorizacionForm.get('descripcion')?.setValue(categorizacion.descripcion);
    this.displayModal = true;
    this.originalValues = { ...this.categorizacionForm.value };
  }

  onSubmit() {
    if (this.categorizacionForm.pristine) {
      this._ms.add({ severity: 'warn', summary: this.translations.advertencia, detail: this.translations.noCambiosFormulario });
      return;
    }

    if (this.categorizacionForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.categorizacionForm);
      this._ms.add({ severity: 'warn', summary: this.translations.exito, detail: this.translations.porFavorCompleteTodosLosCamposRequeridos });
      return;
    }

    const newValues = {
      descripcion: this.categorizacionForm.get('descripcion')?.value,
    } as CategorizacionTramiteDto;

    if (this.isNewForm) {
      this.createCategorizacionTramite(newValues);
    } else if (!Utils.isDeepEqual(this.originalValues, newValues)) {
      this.updateCategorizacionTramite(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.translations.advertencia, detail: this.translations.noCambiosFormulario });
    }
  }

  deleteConfirmation(event: Event, categoria: ICategorizacionTramite) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.translations.estasSeguroDeQueQuieresEliminarLaCategoria,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteCategorizacionTramite(categoria.id);
      },
      reject: () => {

      }
    });
  }

  resetForm() {
    this.categorizacionForm.reset();
  }

  abrirHistorial(data: ICategorizacionTramite): void {
    this.historico.show(data.id);
  }

  abrirHistorialEliminado(): void {
    this.historico.showEliminado();
  }

  //#region API Calls
  getCategorizaciones() {
    this._ct.getCategorizaciones().subscribe({
      next: (data: ICategorizacionTramite[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  createCategorizacionTramite(categoria: CategorizacionTramiteDto) {
    this._lps.show(true);
    this._ct.createCategorizacionTramite(categoria).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.translations.exito, detail: response });
        this.getCategorizaciones();
        this.displayModal = false;
      }
    });
  }

  updateCategorizacionTramite(categoria: CategorizacionTramiteDto) {
    if (!this._editCategorizacion) return;
    this._lps.show(true);
    this._ct.updateCategorizacionTramite(this._editCategorizacion.id, categoria).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.translations.exito, detail: response });
        this.getCategorizaciones();
        this.displayModal = false;
      }
    });
  }

  deleteCategorizacionTramite(categoriaId: number) {
    this._lps.show(true);
    this._ct.deleteCategorizacionTramite(categoriaId).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.translations.exito, detail: response });
        this.getCategorizaciones();
      }
    });
  }
  //#endregion
}
